import { Component, OnInit } from '@angular/core';
import { ServicioAutenticacion } from '../auth/auth.service';

declare var bootstrap: any;

@Component({
  selector: 'app-modal-facturas-pendientes',
  templateUrl: './modal-facturas-pendientes.component.html',
  styleUrls: ['./modal-facturas-pendientes.component.css'],
})
export class ModalFacturasPendientesComponent implements OnInit {
  private modal: any;
  tiempoRestanteSesion = '0 segundos';

  constructor(private servicioAutenticacion: ServicioAutenticacion) {}

  ngOnInit(): void {
    // Inicializar el modal de Bootstrap
    this.modal = new bootstrap.Modal(
      document.getElementById('modalFacturasPendientes'),
      {
        backdrop: 'static',
        keyboard: false,
      }
    );
  }

  mostrarModal(): void {
    this.tiempoRestanteSesion =
      this.servicioAutenticacion.obtenerTiempoRestanteSesionFormateado();

    if (this.modal) {
      this.modal.show();
    }
  }
  ocultarModal(): void {
    if (this.modal) {
      this.modal.hide();
    }
  }

  onEntendidoClick(): void {
    this.ocultarModal();
  }
}
